import axios from 'axios';

const instance = axios.create({
  withCredentials: true,
  baseURL: `${process.env.VUE_APP_DJANGO_PUBLIC_URL}`,
});

const headers = {
  'X-CSRFToken': '',
  'Content-Type': 'application/json',
};

/*
* Update the headers of this instance given the app cookie data
* @params { cookies<Object> }
* @return { void }
*/
export const configInstance = (cookies) => {
  if (cookies.get('csrftoken')) {
    /* eslint-disable dot-notation */
    headers['X-CSRFToken'] = cookies.get('csrftoken');
  }
};

export const postToDiscussions = (data, callback) => {
  const newHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest',
  };
  /* eslint-disable dot-notation */
  instance.defaults.headers.common['X-CSRFToken'] = headers['X-CSRFToken'];
  instance.post('/comments/api/discussion/', data, { newHeaders })
    .then(() => {
      callback(true);
    })
    .catch(() => {
      callback(false);
    });
};

export const fetchComments = (queryData) => {
  const {
    searchTerm,
    commentType,
    dealId,
    breakCache,
    filterQuery,
    sortQuery,
  } = queryData;
  const queryUrl = (searchTerm)
    ? `/api/v2/deals/search_comments/?query=${searchTerm}&comment_type=${commentType}&deal_id=${dealId}&cache=${breakCache}`
    : `/discussions/api/listcomments/${dealId}/?group=${commentType}${filterQuery + sortQuery}&cache=${breakCache}`;
  return instance.get(queryUrl);
};

export const updateAction = (data) => {
  const {
    commentUserId,
    id,
    type,
    value,
    done,
  } = data;

  switch (type) {
    case 'approved': {
      let action = '1';
      if (typeof value === 'undefined' || value === null) {
        action = 'null';
      } else if (!value) {
        action = '0';
      }
      instance.get(`/comments/approve_comment_ajx/?comment_id=${id}&approve_action=${action}`)
        .then((response) => {
          const { success } = (response && response.data) || {};
          done({ type, value, error: !success });
        })
        .catch(() => {
          done({ type, value, error: true });
        });
      return;
    }

    case 'resolved': {
      const reqData = { xtdcomment_ptr_id: id, resolved: value };
      instance.put(
        `/discussions/api/resolved/${id}/`,
        reqData,
        { headers },
      )
        .then((response) => {
          const { xtdcomment_ptr_id: cId, resolved } = (response && response.data) || {};
          done({ type, value: resolved, error: !(cId >= 0) });
        })
        .catch(() => {
          done({ type, value, error: true });
        });
      return;
    }

    case 'pinned': {
      const action = value ? 1 : 0;
      instance.get(`/comments/pin_comment_ajx/?comment_id=${id}&pin_action=${action}`)
        .then((response) => {
          const { success } = (response && response.data) || {};
          done({ type, value, error: !success });
        })
        .catch(() => {
          done({ type, value, error: true });
        });
      return;
    }

    case 'blacklist':
    case 'whitelist': {
      const action = value ? 1 : 0;
      instance.get(`/comments/${type}_author_ajx/?user_id=${commentUserId}&${type}_action=${action}`)
        .then((response) => {
          const { success } = (response && response.data) || {};
          done({ type, value, error: !success });
        })
        .catch(() => {
          done({ type, value, error: true });
        });
      return;
    }

    case 'upvote': {
      instance.post(
        `/comments/like/${id}/`,
        {},
        { headers },
      )
        .then((response) => {
          const { success, upvote_count: upvoteCount } = (response && response.data) || {};
          done({ type, value: upvoteCount, error: !success });
        })
        .catch(() => {
          done({ type, value, error: true });
        });
      return;
    }

    default:
      break;
  }
  done({ type, value, error: true });
};
